import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2dd022cc"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "card"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createBlock(_component_router_link, {
    to: {
      path: $props.url,
      query: {
        detail: $props.detail,
        jobType: $props.jobType
      }
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h4", null, _toDisplayString($props.content), 1), _hoisted_2])]),
    _: 1
  }, 8, ["to"]);
}